module.exports = __webpack_public_path__ + "static/music-cc6d14a0369ec346d4e041dd9968d194.png";